import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './index';

/**
 * Typed replacements for the raw hooks.
 *
 * Always use these. `useSelector` untyped gives `state: unknown`, so every
 * selector needs a manual annotation and a typo in a slice name is not caught.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
